<template>
  <Popup title="报警器告警" minHeight="100%" ref="popup">
    <ul v-if="alarmData.length" class="list">
      <li class="list-item" v-for="item in alarmData" :key="item.userId">
        <div v-for="detail in list" :key="detail.prop">
          <span class="list-item__label">{{ detail.label }}</span>
          <span class="list-item__value">{{ item[detail.prop] || '--' }}</span>
        </div>
        <div
          v-if="item.evStatus === '0'"
          style="text-align: center; margin: 16px"
        >
          <van-button
            type="warning"
            size="small"
            :loading="loading && currId === item.id"
            :disabled="loading && currId === item.id"
            loading-text="正在解除..."
            @click="handleCancel(item.id)"
            >解除告警</van-button
          >
        </div>
      </li>
    </ul>
    <Empty v-else description="无告警信息" />
  </Popup>
</template>

<script>
import { ref, computed } from 'vue'
import { handleEventCancel } from '@/api/customer'
import { Toast } from 'vant'
import { useStore } from 'vuex'
export default {
  name: 'AlarmAlarm',
  emits: ['alarm-cancel'],
  setup(prop, { emit }) {
    const popup = ref(null)
    const alarmData = ref({})
    const showPopup = (data) => {
      console.log(data)
      alarmData.value = data.list
      popup.value.showPopup()
    }
    const list = [
      {
        label: '客户名称',
        prop: 'companyName'
      },
      {
        label: '电话',
        prop: 'phoneNum'
      },
      {
        label: '告警状态',
        prop: 'evStatusName'
      },
      {
        label: '告警设备',
        prop: 'eqName'
      },
      {
        label: '告警时间',
        prop: 'evTime'
      },
      {
        label: '气体浓度',
        prop: 'voltage'
      },
      {
        label: '信号强度',
        prop: 'rssi'
      },
      {
        label: '事件类型',
        prop: 'payloadName'
      }
    ]
    const loading = ref(false)
    const currId = ref('')
    const store = useStore()
    const userName = computed(() => store.state.userInfo.username)
    const handleCancel = (id) => {
      currId.value = id
      loading.value = true
      handleEventCancel({ id, userid: userName.value })
        .then(() => {
          loading.value = false
          alarmData.value = alarmData.value.map((item) => {
            if (item.id === id) {
              item.evStatus = '1'
              item.evStatusName = '已解除'
            }
            return item
          })
          Toast.success('解除成功')
          emit('alarm-cancel')
        })
        .catch(() => {
          loading.value = false
        })
    }
    return {
      popup,
      showPopup,
      list,
      alarmData,
      handleCancel,
      loading,
      currId
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 16px;
  padding-bottom: 0;
  font-size: 14px;
  color: #666;
  .list-item {
    line-height: 24px;
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    &__label {
      color: #666;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      width: 60px;
      text-align: right;
    }
    &__value {
      color: #333;
      font-size: 14px;
    }
  }
}
</style>
